export default function stripHtmlTags(input: string): string {
	if (!input) return '';

	// create a div to get all decoded entities like &nbsp;
	const doc = document.createElement('div');

	doc.innerHTML = input;

	const text = doc.textContent || '';

	doc.remove();

	return text.trim();
}
